/* eslint-disable prettier/prettier */
/* eslint-disable jsx-a11y/label-has-associated-control */
import VisibilityIcon from '@mui/icons-material/Visibility';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useLocation } from 'react-use';
import { z } from 'zod';
import CopiedLinkModal from '../../../components/elements/CopyLink';
import { getAsync, postAsync, reactURL } from '../../../components/helper/axiosHelper';
import { PageHitCountApi } from '../../../shared/Helper';

const DonorRegistration = () => {
  const isActive = useSelector((state) => state.toggle.isActive);
  const [email, setEmail] = useState('');
  const [mobile, setMobile] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [link, setLink] = useState("");

  //const [allRequirementsMetCreatePassword, setAllRequirementsMetCreatePassword] = useState(false);
  const [allRequirementsMetConfirmPassword, setAllRequirementsMetConfirmPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState('');
  const [fullname, setFullname] = useState('');
  const [username, setUsername] = useState('');
  const [countryAPIData, setCountryAPIData] = useState([]);
  const [emiratesAPIData, setEmiratesAPIData] = useState([]);
  const [selectedCountryID, setSelectedCountryID] = useState(208);
  const [selectedEmiratesID, setSelectedEmiratesID] = useState(0);
  const [formerror, setFormerror] = useState({});
  const [showhide, setShowhide] = useState(0);
  const [formData, setFormData] = useState({
    countryID: '208',
    emiratesID: 0,
  });
  const [showModal, setShowModal] = useState(false);


  const { t } = useTranslation();
  const navigate = useNavigate();

  const { pathname } = useLocation();

  useEffect(() => {
    PageHitCountApi(pathname, 0);
  }, []);


  const user = z.object({
    email: z
      .string()
      .email('Please provide a valid email')
      .refine((value) => value.trim() !== '', {
        message: 'Email is required',
      }),
    mobile: z
      .string()
      .min(5, 'Number must contain min 5 digits')
      .max(50, 'Number must contain max  50 digits')
      .refine((value) => value && /[0-9]/.test(value), {
        message: 'Mobile number is required',
      }),
    password: z
      .string()
      .min(8, 'Must be 8 or more characters long')
      .refine((value) => /[0-9]/.test(value), 'Must contain at least one number')
      .refine((value) => /[a-z]/.test(value), 'Must contain at least one lowercase letter')
      .refine((value) => /[A-Z]/.test(value), 'Must contain at least one uppercase letter'),
    confirmPassword: z.string().refine((value) => value === password, 'Passwords must match', true),
    fullname: z
      .string()
      .min(3, 'Must be 3 or more characters long')
      .max(50, 'Must be 50 characters long')
      .refine((value) => value || /[a-z]/.test(value), 'Full Name is required')
      .refine((value) => value || /[A-Z]/.test(value), 'Full Name is required'),
    username: z
      .string()
      .min(3, 'Must be 3 or more characters long')
      .max(50, 'Must be 50 characters long')
      .refine((value) => value || /[a-z]/.test(value), 'Username is required')
      .refine((value) => value || /[A-Z]/.test(value), 'Username is required'),
    // countryID: z.number().refine((value) => value && /[0-9]/.test(value), {
    //   message: 'Please select Country.',
    // }),
    // emiratesID: z.number().refine((value) => value && /[0-9]/.test(value), {
    //   message: 'Please select Country.',
    // }),
  });

  const handleComponentMount = () => {
    setShowhide(208);
  };

  const getCountries = async () => {
    await getAsync('Utilities/GetCountryList')
      .then((response) => {
        const result = response?.data;
        setCountryAPIData(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const getEmirates = async () => {
    await getAsync('Utilities/GetEmiratesList')
      .then((response) => {
        const result = response?.data;
        setEmiratesAPIData(result);
      })
      .catch((error) => {
        toast.error(t('Something went wrong, Please try again!'));
      });
  };

  const handleOnSelectCountry = (selectedCountry) => {
    const id = selectedCountry.target.value;
    setSelectedCountryID(id);
    setShowhide(id);
    if (id == 208) {
      getEmirates();
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    // setIsUserDataUpdated(true);
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === 'countryID') {
      if (value == 208) {
        setShowhide(value);
      } else {
        setFormData((prev) => ({
          ...prev,
          emiratesID: 0,
        }));
        setShowhide(0);
      }
    }
  };

  const handleOnSelectEmirate = (selectedEmirates) => {
    const emirates = selectedEmirates.target.value;
    if (emirates == null || emirates == undefined || emirates == 0) {
      setSelectedEmiratesID(0);
    }
    setSelectedEmiratesID(emirates);
  };

  useEffect(() => {
    // handleComponentMount();
    getCountries();
    passwordValidate();
    getEmirates();
  }, []);

  const bodyCreate = {
    email,
    username,
    fullname,
    mobile,
    countryID: formData.countryID,
    emiratesID: formData.emiratesID ?? 0,
    password,
    confirmPassword,
  };

  const handleApiWork = async (link, resp) => {

    const payload = {
      username: resp.userName,
      forgotLink: link,
      email: resp.email,
      mobile: resp.mobile,
      linkType: 2,
      message: ""
    }

    await postAsync('EP_UserAuthentication/SendResetPasswordtLink', payload)
      .then((response) => {
        console.log(response, "responseresponse")

        if (response?.statusCode === 200) {
          toast.success(t("Reset Password link has been sent to your registered email. Please check your email to proceed."));
        }
        if (response?.statusCode === 400) {
          toast.success(t("Something went wrong, Please try again!"));
        }

      })
      .catch((error) => {
        console.log(error, "errorerrorerror")
        toast.error(t('Something went wrong, Please try again!'));
      });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const parseuser = user.safeParse(bodyCreate);
    if (!parseuser.success) {
      const error = parseuser.error;
      let newerror = {};
      for (const issue of error.issues) {
        newerror = { ...newerror, [issue.path]: issue.message };
      }
      return setFormerror(newerror);
    } else {

      await postAsync('EP_UserAuthentication/RegisterEPUser', bodyCreate)
        .then((response) => {
          if (response?.statusCode === 200) {
            toast.success(t("Successfully Registered"));
            const link = `${reactURL}/activate/${response?.data[0]?.activeGUID}`;
            console.log('Send', link);
            handleApiWork(link, response?.data[0])

            setLink(link)
            setShowModal(true)
            // toast.success(t('Activation Link send Successfully.'));
            // Clear state values
            setEmail('');
            setMobile('');
            setPassword('');
            setConfirmPassword('');
            setFullname('');
            setUsername('');
            setSelectedCountryID('');
            setSelectedEmiratesID('');
            // navigate('/donorLogin');
          } else {
            toast.warning(`${response?.message}`);
          }
        })
        .catch((error) => {
          console.log(error, "errorerrorerror")
          toast.error(t('Something went wrong, Please try again!'));
        });
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const toggleConfirmPasswordVisibility = () => {
    setShowConfirmPassword(!showConfirmPassword);
  };

  const requirements = useMemo(
    () => [
      { regex: /.{8,}}/, text: 'At least 8 characters length' },
      { regex: /.[0-9]}/, text: 'At least 1 number {0...9}' },
      { regex: /.{a-z}}/, text: 'At least 1 lowercase letter (a...z)' },
      { regex: /.{^A-Za-z0-9}}/, text: 'At least 1 special symbol (!...$)' },
      { regex: /.{A-Z}}/, text: 'At least 1 upper letter  (A...Z)' },
    ],
    [],
  );

  const passwordValidate = () => {
    const passwordMet = requirements.every((req) => req.regex.test(password));
    setAllRequirementsMetConfirmPassword(passwordMet);
    const confirmPasswordMet = requirements.every((req) => req.regex.test(confirmPassword));
    setAllRequirementsMetConfirmPassword(confirmPasswordMet);
  };
  return (
    <div className="pt-12 xl:pt-28 items-center">
      <div className="container-fluid ">
        <div
          className="py-10"
          style={ {
            background: `transparent url('./assets/Sharjah-stroke-logo-1.png') left top 0px no-repeat`,

            width: '100%',
          } }
        >
          { ' ' }
        </div>
        <div className="row justify-center items-center">
          <div className=" flex justify-center items-center pt-10 pb-10 md:pb-20 col-lg-6">
            <form className="w-full">
              <div className="card rounded-4xl shadow-customgreen bg-green-50">
                <div className="card-body">
                  <div className="row justify-center items-center">
                    <div className="col-lg-3 flex justify-center">
                      <div className="w-24 h-24 mb-3 flex items-center justify-center rounded-full border-2 border-customgreen">
                        <svg
                          version="1.0"
                          xmlns="http://www.w3.org/2000/svg"
                          width="50.000000pt"
                          height="50.000000pt"
                          viewBox="0 0 290.000000 350.000000"
                          preserveAspectRatio="xMidYMid meet"
                        >
                          <g
                            transform="translate(0.000000,300.000000) scale(0.050000,-0.050000)"
                            fill="#057A55"
                            stroke="none"
                          >
                            <path d="M2680 5960 c-187 -44 -329 -94 -420 -149 -38 -23 -97 -55 -129 -71 -110 -55 -416 -382 -498 -530 -629 -1145 264 -2509 1542 -2356 1139 136 1749 1342 1192 2356 -82 148 -388 475 -498 530 -32 16 -90 48 -129 72 -266 161 -728 226 -1060 148z" />
                            <path d="M2370 2467 c-1099 -158 -1942 -1062 -1985 -2129 l-10 -251 55 -44 55 -43 2515 0 2515 0 55 43 55 44 -10 251 c-31 769 -460 1444 -1195 1876 -103 60 -365 158 -560 209 -164 42 -1273 75 -1490 44z" />
                          </g>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="row justify-center items-center">
                    <div className="col-lg-6 text-center">
                      <h2 className="text-xl text-customgreen font-semibold">{ t('User Registration') }</h2>
                    </div>
                  </div>

                  <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                    <div className="form-group py-2">
                      <label>
                        { t('Email') }
                        <span className="errmsg">*</span>
                      </label>
                      <input
                        value={ email }
                        placeholder={ t('Email') }
                        onChange={ (e) => setEmail(e.target.value) }
                        type="email"
                        className="border border-gray-300 text-gray-900 focus:ring-2 focus:ring-customgreen text-sm rounded-lg block w-full p-2.5"
                      />
                      { formerror.email && <p className="text-red-700">{ t(formerror.email) }</p> }
                    </div>

                    <div className="form-group py-2">
                      <label>
                        { t('Username') }
                        <span className="errmsg">*</span>
                      </label>
                      <input
                        value={ username }
                        placeholder={ t('Username') }
                        minLength={ 3 }
                        maxLength={ 25 }
                        onChange={ (e) => setUsername(e.target.value) }
                        type="text"
                        className="border border-gray-300 text-gray-900 focus:ring-2 focus:ring-customgreen text-sm rounded-lg block w-full p-2.5"
                      />
                      { formerror.username && <p className="text-red-700">{ t(formerror.username) }</p> }
                    </div>

                    <div className="form-group py-2">
                      <label>
                        { t('Full Name') }
                        <span className="errmsg">*</span>
                      </label>
                      <input
                        value={ fullname }
                        placeholder={ t('Full Name') }
                        minLength={ 3 }
                        maxLength={ 25 }
                        onChange={ (e) => setFullname(e.target.value) }
                        type="text"
                        className="border border-gray-300 text-gray-900 text-sm focus:ring-2 focus:ring-customgreen rounded-lg block w-full p-2.5"
                      />
                      { formerror.fullname && <p className="text-red-700">{ t(formerror.fullname) }</p> }
                    </div>

                    <div className="form-group py-2">
                      <label>
                        { t('Mobile') }
                        <span className="errmsg">*</span>
                      </label>
                      <input
                        value={ mobile }
                        onChange={ (e) => setMobile(e.target.value) }
                        onKeyDown={ (e) => {
                          const isValidChar = /^[0-9+]$/.test(e.key) || e.key === 'Backspace' || e.key === 'Delete';
                          if (!isValidChar) {
                            e.preventDefault();
                          }
                        } }
                        type="text"
                        placeholder={ t('Mobile') }
                        pattern="[0-9+]+"
                        maxLength={ 13 }
                        className="border border-gray-300 text-gray-900 text-sm focus:ring-2 focus:ring-customgreen rounded-lg block w-full p-2.5"
                        autoComplete="off"
                      />
                      <p className="mt-2 text-sm">{ t('Your mobile number should starts with +971.') } </p>
                      { formerror.mobile && <p className="text-red-700">{ t(formerror.mobile) }</p> }
                    </div>

                    <div className="form-group py-2">
                      <label>
                        { t('Country') }
                        <span className="errmsg">*</span>
                      </label>
                      {/* <select
            value={selectedCountryID}
            onChange={(e) => handleOnSelectCountry(e.target.value)}
            className="form-control border border-gray-300 text-gray-900 focus:ring-2 focus:ring-customgreen text-sm rounded-lg block w-full p-2.5"
          >
            <option value="0">--SELECT--</option>
            {countryAPIData && countryAPIData.length > 0 ? (
              countryAPIData.map((item) => (
                <option key={item.countryID} value={item.countryID}>
                  {item.countryName}
                </option>
              ))
            ) : (
              <option>No country found</option>
            )}
          </select> */}

                      {/* New Code */ }
                      <select
                        disabled="true"
                        className="form-control border border-gray-300 text-gray-900 focus:ring-2 focus:ring-customgreen text-sm rounded-lg block w-full p-2.5"
                        name="countryID"
                        onChange={ handleChange }
                        // disabled={!isEditing}
                        value={ formData.countryID } // Bind the selected value to the state
                      >
                        <option value={ '' }>--{ t('SELECT') }--</option> {/* Default select option */ }
                        { countryAPIData && countryAPIData.length > 0 ? (
                          countryAPIData.map((item) => (
                            <option key={ item.countryID } value={ item.countryID }>
                              { isActive ? item?.ar_SA : item.countryName }
                            </option>
                          ))
                        ) : (
                          <option>{ t('No country found') }</option>
                        ) }
                      </select>

                      { formerror.countryID && <p className="text-red-700">{ t(formerror.countryID) }</p> }
                    </div>

                    {/* {showhide == 208 && (
                      <div className="form-group py-2">
                        <label>
                          {t('Emirates')}
                          <span className="errmsg">*</span>
                        </label>
                        <select
                          value={selectedEmiratesID}
                          onChange={(e) => handleOnSelectEmirate(e.target.value)}
                          className="form-control border border-gray-300 text-gray-900 focus:ring-2 focus:ring-customgreen text-sm rounded-lg block w-full p-2.5"
                        >
                          <option value="0">--SELECT--</option>
                          {emiratesAPIData && emiratesAPIData.length > 0 ? (
                            emiratesAPIData.map((item) => (
                              <option key={item.emiratesID} value={item.emiratesID}>
                                {item.en_US}
                              </option>
                            ))
                          ) : (
                            <option>No Emirates found</option>
                          )}
                        </select>
                        {formerror.emiratesID && <p className="text-red-700">{formerror.emiratesID}</p>}
                      </div>
                    )} */}

                    {/* new Code */ }
                    { formData.countryID == 208 && (
                      <div className="form-group py-2">
                        <label>
                          { t('Emirates') }
                          <span className="errmsg">*</span>
                        </label>
                        <select
                          className="form-control border border-gray-300 text-gray-900 focus:ring-2 focus:ring-customgreen text-sm rounded-lg block w-full p-2.5"
                          name="emiratesID"
                          onChange={ handleChange }
                          // disabled={!isEditing}
                          value={ formData.emiratesID } // Bind the selected value to the state
                        >
                          <option value={ '' }>--{ t('SELECT') }--</option> {/* Default select option */ }
                          { emiratesAPIData && emiratesAPIData.length > 0 ? (
                            emiratesAPIData.map((item) => (
                              <option key={ item.emiratesID } value={ item.emiratesID }>
                                { t(isActive ? item?.ar_SA : item?.en_US) }
                              </option>
                            ))
                          ) : (
                            <option>{ t('No Emirates found') }</option>
                          ) }
                        </select>
                      </div>
                    ) }

                    <div className="form-group py-2">
                      <label>
                        { t('Password') }
                        <span className="errmsg">*</span>
                      </label>
                      <div className="relative flex">
                        <input
                          value={ password }
                          placeholder={ t('Password') }
                          onChange={ (e) => setPassword(e.target.value) }
                          type={ showPassword ? 'text' : 'password' }
                          className="border border-gray-300 text-gray-900 text-sm focus:ring-2 focus:ring-customgreen rounded-lg block w-full p-2.5"
                          pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}"
                          title="Must contain at least one number and one uppercase and lowercase letter, and at least 8 or more characters"
                          required
                        />
                        <button
                          type="button"
                          className={ `eye-button absolute top-1/2 transform -translate-y-1/2 ${isActive ? 'left-1' : 'right-1'}` }
                          style={ { backgroundColor: 'transparent', border: '0' } }
                          onClick={ togglePasswordVisibility }
                        >
                          { showPassword ? <VisibilityIcon /> : <VisibilityOffIcon /> }
                        </button>
                      </div>
                      { formerror.password && <p className="text-red-700">{ t(formerror.password) }</p> }
                    </div>

                    <div className="form-group py-2">
                      <label>
                        { t('Confirm Password') }
                        <span className="errmsg">*</span>
                      </label>
                      <div className="relative flex">
                        <input
                          value={ confirmPassword }
                          placeholder={ t('Confirm Password') }
                          onChange={ (e) => setConfirmPassword(e.target.value) }
                          type={ showConfirmPassword ? 'text' : 'password' }
                          className="border border-gray-300 text-gray-900 text-sm focus:ring-2 focus:ring-customgreen rounded-lg block w-full p-2.5"
                        />
                        <button
                          type="button"
                          className={ `eye-button absolute top-1/2 transform -translate-y-1/2 ${isActive ? 'left-1' : 'right-1'}` }
                          style={ { backgroundColor: 'transparent', border: '0' } }
                          onClick={ toggleConfirmPasswordVisibility }
                        >
                          { showConfirmPassword ? <VisibilityIcon /> : <VisibilityOffIcon /> }
                        </button>
                      </div>
                      { formerror.confirmPassword && <p className="text-red-700">{ t(formerror.confirmPassword) }</p> }
                    </div>
                  </div>

                  <div className="card-footer border-0 flex justify-center items-center mt-4">
                    <button
                      type="submit"
                      onClick={ handleSubmit }
                      className="text-white bg-customgreen hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-8 py-2.5 text-center me-1"
                    >
                      { t('Register') }
                    </button>
                    <Link
                      to={ '/donorLogin' }
                      className="text-white bg-customgreen w-32 hover:bg-hovergreen focus:outline-none focus:ring-4 focus:ring-customgreen font-medium rounded-full text-sm px-8 py-2.5 text-center ms-1"
                    >
                      { t('Back') }
                    </Link>
                  </div>
                </div>
              </div>

              {
                showModal && <CopiedLinkModal link={ link } showModal={ showModal } setShowModal={ setShowModal } />
              }
            </form>
          </div>
        </div>
      </div>

    </div>
  );
};

export default DonorRegistration;
